import type { DynamicQuestionAnswerValue } from './types';

export function commitExternalOffenderValue(
  input: string,
  currentTextValues: string[] | undefined,
  allowMultiSelect: boolean,
): DynamicQuestionAnswerValue['textValues'] {
  const newNames = input
    .split(',')
    .map((n) => n.trim())
    .filter((n) => n.length > 0);

  if (newNames.length === 0) {
    return currentTextValues;
  }

  if (allowMultiSelect) {
    return [...(currentTextValues ?? []), ...newNames];
  }

  return newNames.slice(0, 1);
}
